import axios from "axios";
import { REACT_APP_EXTERNAL_API_HOST } from "../config";
import { signOut } from "./auth-action";

const externalApiHost =
  (process.env.REACT_APP_EXTERNAL_API_HOST || REACT_APP_EXTERNAL_API_HOST)
    .replace(/\/$/, "");

const AUTH_FAILURE_MESSAGES = [
  "authentication failed",
  "please log in again",
  "please login again",
  "unauthorized",
  "status code: 401",
];

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  "X-Requested-With": "stockhero-web",
});

const url = (path) => `${externalApiHost}${path}`;

const isAuthFailure = (errorOrData) => {
  const status =
    errorOrData?.response?.status ??
    errorOrData?.status ??
    errorOrData?.code ??
    errorOrData?.response?.data?.code ??
    errorOrData?.response?.data?.status ??
    errorOrData?.response?.data?.status_code ??
    errorOrData?.status_code;

  if (Number(status) === 401) {
    return true;
  }

  const message = String(
    errorOrData?.response?.data?.message ??
      errorOrData?.response?.data?.error ??
      errorOrData?.message ??
      errorOrData?.error ??
      errorOrData
  ).toLowerCase();

  return AUTH_FAILURE_MESSAGES.some((authMessage) =>
    message.includes(authMessage)
  );
};

const requestExternalApi = (method, path, data) => (dispatch, getState) => {
  const token = getState().auth.token;

  return new Promise((resolve, reject) => {
    axios({
      method,
      url: url(path),
      data,
      headers: headers(token),
    })
      .then((res) => {
        if (isAuthFailure(res?.data)) {
          dispatch(signOut());
          reject(new Error("Authentication required. Please sign in again."));
          return;
        }

        resolve(res.data);
      })
      .catch((error) => {
        if (isAuthFailure(error)) {
          dispatch(signOut());
        }

        reject(error);
      });
  });
};

export const loadExternalApiKey = () =>
  requestExternalApi("get", "/external-management/v1/key");

export const sendExternalApiEmailOtp = () =>
  requestExternalApi("post", "/external-management/v1/email-otp", {});

export const verifyExternalApiEmailOtp = (otp) =>
  requestExternalApi("post", "/external-management/v1/email-otp/verify", { otp });

export const verifyExternalApiGoogleOtp = (otp) =>
  requestExternalApi("post", "/external-management/v1/google-otp/verify", { otp });

export const createExternalApiKey = (payload) =>
  requestExternalApi("post", "/external-management/v1/key", payload);

export const regenerateExternalApiKey = (payload) =>
  requestExternalApi("post", "/external-management/v1/key/regenerate", payload);

export const updateExternalApiIp = (payload) =>
  requestExternalApi("put", "/external-management/v1/key/ip", payload);

export const revokeExternalApiKey = () =>
  requestExternalApi("delete", "/external-management/v1/key", { confirm: "revoke" });

export const externalApiError = (error) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  "Request failed";
